import { Route, Routes } from 'react-router';
import {
    ROUTE_RESET_PASSWORD,
    ROUTE_SET_PASSWORD,
    ROUTE_SUPPORT,
} from '../constants/URLS.const';
import { PublicRoute } from './PublicRoute';
import { Suspense, lazy } from 'react';
import { AuthScreenLoading } from '@src/components';
import { SetPassword } from '@src/pages/Auth/SetPassword';
import { Support } from '@src/pages/Support';

const SignIn = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
        default: module.SignIn,
    }))
);

const ResetPassword = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
        default: module.ResetPassword,
    }))
);

export function AuthenticationRoutes() {
    return (
        <Suspense fallback={<AuthScreenLoading />}>
            <Routes>
                <Route element={<PublicRoute />}>
                    <Route index element={<SignIn />} />
                    <Route
                        path={ROUTE_RESET_PASSWORD}
                        element={<ResetPassword />}
                    />
                    <Route
                        path={ROUTE_SET_PASSWORD}
                        element={<SetPassword />}
                    />
                    <Route path={ROUTE_SUPPORT} element={<Support />} />
                </Route>
            </Routes>
        </Suspense>
    );
}
